module.exports = __webpack_public_path__ + "img/ACOS.6ae483df.svg";